export interface HsSparseCullingCandidates {
  indices: Uint32Array;
  count: number;
}

export function hsCollectSparseCullingCandidates<T extends { name?: string }>(
  objects: readonly T[],
  mask: Uint8Array,
  indices: Uint32Array
): number | null {
  let count: number = 0;
  for (let index: number = 0; index < mask.length; index++) {
    if (mask[index] !== 0 || objects[index].name?.startsWith('debug-') === true) {
      if (count === indices.length) {
        return null;
      }
      indices[count++] = index;
    }
  }
  return count;
}

export function* hsIterateSparseCullingCandidates<T>(
  objects: readonly T[],
  candidates: HsSparseCullingCandidates
): IterableIterator<T> {
  for (let cursor: number = 0; cursor < candidates.count; cursor++) {
    yield objects[candidates.indices[cursor]];
  }
}
